module.exports = __webpack_public_path__ + "static/media/icons-ic-prospect-interested.9ec0d387.svg";